import { connect } from 'react-redux'
import * as Sentry from '@sentry/browser'

export default connect(({ user }) => {
  if (!user) return {}
  return {
    email: user.email,
    name: user.name,
    workspace: user.workspace
  }
})(({ email, name, workspace }) => {
  if (!email) return null
  Sentry.configureScope((scope) => {
    scope.setUser({
      email,
      username: name,
      workspace
    })
  })
  return null
})



// WEBPACK FOOTER //
// ./src/SentryScope.js